import { CampaignProduct } from "../dto/campaign-product.model";

	/**
	 * @description
	 *  Ítems de reemplazo asociados a una nota de CyR o NC, sobre un pedido.
	 *
	 * @see gigot-backend/ViewModels/OrderEvent/ReplacementItemForCreation.cs
	 */

export class ReplacementItemForCreation {

	public campaignProductReplacementId: number;
	public orderEventId: number;
	public quantity: number;

	/**
	 * @description
	 *	Construye un ítem de reemplazo con una semántica vacía. Nótese que no
	 *	es lo mismo que construir un ítem con valores por defecto. Las reglas
	 *	generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un ítem de reemplazo vacío.
	 */
	public static empty(): ReplacementItemForCreation {
		const replacementItemForCreation: ReplacementItemForCreation = new ReplacementItemForCreation();
		replacementItemForCreation.campaignProductReplacementId = undefined;
		replacementItemForCreation.orderEventId = undefined;
		replacementItemForCreation.quantity = undefined;
		return replacementItemForCreation;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicReplacementItemForCreation
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicReplacementItemForCreation: ReplacementItemForCreation): ReplacementItemForCreation {
		if (!anemicReplacementItemForCreation) return undefined;
		const replacementItemForCreation: ReplacementItemForCreation = ReplacementItemForCreation.empty();
		replacementItemForCreation.campaignProductReplacementId = anemicReplacementItemForCreation.campaignProductReplacementId;
		replacementItemForCreation.orderEventId = anemicReplacementItemForCreation.orderEventId;
		replacementItemForCreation.quantity = anemicReplacementItemForCreation.quantity;
		return replacementItemForCreation;
	}

	/**
	 * @description
	 *	.
	 *
	 * @param campaignProduct
	 *	.
	 * @param quantity
	 *	.
	 *
	 * @returns
	 *	.
	 */
	public static fromCampaignProduct(campaignProduct: CampaignProduct, quantity: number): ReplacementItemForCreation {
		if (!campaignProduct) return undefined;
		const replacementItemForCreation: ReplacementItemForCreation = ReplacementItemForCreation.empty();
		replacementItemForCreation.campaignProductReplacementId = campaignProduct.id;
		replacementItemForCreation.orderEventId = undefined;
		replacementItemForCreation.quantity = quantity;
		return replacementItemForCreation;
	}
}
